import { Playlist } from "@/components/playlists/Playlist";
import {
  // useIsDemoApp,
  useIsPartnerApp,
} from "@/store/selectors/featureSelectors";
import { AdvizerSearchPage } from "./AdvizerSearchPage";
// import { useActiveUserPartner, useIsLoggedIn } from "@/store/selectors";
// import { AdvizerSearchPage } from "./AdvizerSearchPage";

export const HomePage = () => {
  const isPartnerApp = useIsPartnerApp();
  // const isDemoApp = useIsDemoApp();
  // const isLoggedIn = useIsLoggedIn();
  // const userPartner = useActiveUserPartner();

  if (isPartnerApp) {
    return <AdvizerSearchPage />;
  }

  // if ((!isLoggedIn || !userPartner) && !isDemoApp) {
  //   return <AdvizerSearchPage />;
  // }

  return <Playlist />;
};
